export default __webpack_public_path__ + "static/media/1-piece-mantle-empty.81fb8ee3.svg";